import { createReducer, on } from '@ngrx/store';
import { setLiveMode } from './live-mode.actions';

export const liveModeInitialState: string = 'true';

export const liveModeReducer = createReducer(
  liveModeInitialState,
  on(setLiveMode, (state, { liveMode }) => liveMode)
);
